import styles from "./campain.module.css";

import { RiArrowDownSFill } from "react-icons/ri";
const Acordion = ({ index }) => {
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div>
      <p className="px-3 pt-2 pb-2">
        نتایج پیگیری آخرین وضعیت
        <button
          className={`btn text-white ${styles.btnacardeon}`}
          type="button"
          onClick={toggleAccordion}
        >
          <RiArrowDownSFill />
        </button>
      </p>
      <div className="collapse" id={`accordion-${index}`}>
        <div className="px-3 pb-2">
          <p className={styles.text}>
            {" "}
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Acordion;
